import { Outlet } from 'react-router-dom';

export default function App() {
  return (
    <div className="min-h-full flex flex-col">
      <Outlet />
    </div>
  );
}
